import React from 'react';
import PropTypes from 'prop-types';

function CheckboxGroup({ title, options, layout, onChange }) {
  const baseUlClass = "w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white";
  const horizontalLiClass = "w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600";
  const verticalLiClass = "w-full border-b border-gray-200 rounded-t-lg dark:border-gray-600";

  return (
    <div>      
      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{title}</label>
      <ul className={layout === 'horizontal' ? `${baseUlClass} sm:flex` : baseUlClass}>
        {options.map((option, index) => (
          <li key={index} className={layout === 'horizontal' ? horizontalLiClass : verticalLiClass}>
            <div className="flex items-center ps-3">
              <input 
                id={option.id}
                type="checkbox"
                value={option.value}
                checked={option.checked}
                onChange={() => onChange(option.value)}
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
              />
              <label htmlFor={option.id} className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">{option.label}</label>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

CheckboxGroup.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      checked: PropTypes.bool
    })
  ).isRequired,
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
  onChange: PropTypes.func.isRequired
};

export default CheckboxGroup;
